var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("default-layout", [
    _c("div", { staticClass: "py-0 image-header-container" }, [
      _c("div", { staticClass: "image-header" }, [
        _c("div", { staticClass: "text-container py-3" }, [
          _c("div", { staticClass: "mb-0 mt-auto" }, [
            _c(
              "div",
              {
                staticClass: "d-flex mt-auto",
                class: { "d-none": !_vm.isCastillosSelected },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "44",
                      height: "35",
                      viewBox: "0 0 44 35",
                      fill: "none",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M42.7004 34.3056C42.6801 34.3056 42.6597 34.3056 42.6393 34.3056H40.3985L38.6261 14.8508V14.8305V11.571H40.0725C40.2762 11.571 40.4392 11.4081 40.4392 11.2043V7.59858C40.4392 7.39486 40.2762 7.23189 40.0725 7.23189H38.2594C38.0557 7.23189 37.8928 7.39486 37.8928 7.59858V9.04496H36.8131V5.78551C36.8131 5.5818 36.6501 5.41883 36.4464 5.41883H33.2073V4.19653L36.6093 2.48533C36.7927 2.38347 36.8538 2.17975 36.7723 1.99641C36.7316 1.93529 36.6908 1.87418 36.6093 1.83344L33.0443 0.0611146L33.0036 0.040743C32.9832 0.0203715 32.9628 0.0203715 32.9425 0.0203715C32.9425 0.0203715 32.9221 0.0203715 32.9221 0C32.9017 0 32.861 0 32.8406 0C32.8202 0 32.8202 0 32.7999 0C32.7795 0 32.7591 0 32.7388 0H32.7184C32.698 0 32.6776 0.0203715 32.6776 0.0203715C32.6573 0.0203715 32.6369 0.040743 32.6369 0.0611146C32.6165 0.0611146 32.6165 0.0814861 32.5962 0.101858C32.5962 0.101858 32.5758 0.142601 32.5554 0.162972C32.5554 0.162972 32.5554 0.183344 32.535 0.183344V0.203715C32.535 0.203715 32.535 0.224087 32.535 0.244458C32.535 0.26483 32.535 0.285201 32.535 0.305573V0.325944V5.37808H31.0887C30.885 5.37808 30.722 5.54105 30.722 5.74477V9.00421H29.6423V7.55783C29.6219 7.35412 29.4589 7.21152 29.2552 7.23189H27.4625C27.2588 7.23189 27.0958 7.39486 27.0958 7.57821V11.184C27.0958 11.3877 27.2588 11.5507 27.4422 11.5507H28.8885V14.7897L28.42 19.8622H22.4104V18.477C22.4104 18.4566 22.4104 18.4566 22.4104 18.4362V18.3955C22.4104 18.3751 22.4104 18.3547 22.39 18.3344V18.314C22.39 18.2936 22.3697 18.2733 22.3697 18.2529L22.3493 18.2121L20.577 14.6675C20.4751 14.4842 20.2306 14.423 20.0677 14.5453C20.0066 14.586 19.9658 14.6268 19.9454 14.6675L18.1731 18.2121C18.1731 18.2121 18.1731 18.2121 18.1528 18.2325L18.1324 18.2733C18.112 18.2936 18.112 18.314 18.112 18.3547C18.112 18.3751 18.112 18.3955 18.112 18.4362V19.903H13.834L13.3858 14.8305V11.571H14.8322C15.0359 11.571 15.1989 11.4081 15.1989 11.2043V7.59858C15.1989 7.39486 15.0359 7.23189 14.8322 7.23189H13.0395C12.8358 7.23189 12.6728 7.39486 12.6728 7.59858V9.04496H11.5931V7.59858C11.5931 7.39486 11.4302 7.23189 11.2468 7.23189H9.43374C9.23003 7.23189 9.06705 7.39486 9.06705 7.59858V9.04496H7.98736V7.59858C7.98736 7.39486 7.82439 7.23189 7.62068 7.23189H5.80761C5.6039 7.23189 5.44092 7.39486 5.44092 7.59858V9.04496H4.36123V7.59858C4.36123 7.39486 4.19826 7.23189 3.99455 7.23189H2.18148C1.97776 7.23189 1.81479 7.39486 1.81479 7.59858V11.2043C1.81479 11.4081 1.97776 11.571 2.18148 11.571H3.62786V14.7897L1.85554 34.2853H0.388786C0.18507 34.2649 0.0220982 34.4279 0.00172666 34.6112C-0.0186449 34.7946 0.144327 34.9779 0.327671 34.9983C0.348043 34.9983 0.368414 34.9983 0.388786 34.9983H2.12036C2.14074 34.9983 2.14074 34.9983 2.16111 34.9983H2.20185C2.22222 34.9983 2.24259 34.9983 2.28334 34.9983H14.7915C14.8118 34.9983 14.8118 34.9983 14.8322 34.9983H34.6944C34.7148 34.9983 34.7148 34.9983 34.7352 34.9983H42.6801C42.8838 35.0186 43.0467 34.8557 43.0671 34.6723C43.0875 34.489 42.9042 34.3056 42.7004 34.3056ZM33.2277 0.977833L35.6723 2.20012L33.2277 3.42242V0.977833ZM29.6219 14.4638V11.571H37.9335V14.4638H29.6219ZM31.435 6.1522H36.1204V7.23189H34.6741C34.4703 7.23189 34.3074 7.39486 34.3074 7.59858V9.04496H33.2277V7.59858C33.2277 7.39486 33.0647 7.23189 32.8814 7.23189H31.435V6.1522ZM27.8089 10.858V7.96526H28.8885V9.41164C28.8885 9.61536 29.0515 9.77833 29.2552 9.77833H31.0683C31.272 9.77833 31.435 9.61536 31.435 9.41164V7.96526H32.535V9.41164C32.535 9.61536 32.698 9.77833 32.9017 9.77833H34.7148C34.9185 9.77833 35.0815 9.61536 35.0815 9.41164V7.96526H36.1612V9.41164C36.1612 9.61536 36.3242 9.77833 36.5279 9.77833H38.3409C38.5446 9.77833 38.7076 9.61536 38.7076 9.41164V7.96526H39.7873L39.7262 10.858H27.8089ZM20.251 15.625L21.4733 18.0695H19.0287L20.251 15.625ZM18.8046 18.7825H21.6974V21.6957H18.8046V20.616V19.903V18.7825ZM18.0713 20.616V22.042C18.0713 22.2457 18.2342 22.4087 18.438 22.4087H22.0437C22.2474 22.4087 22.4104 22.2457 22.39 22.042V20.616H30.8035L32.3517 25.3014H31.0072C30.9868 25.3014 30.9664 25.3014 30.9461 25.3014C30.9257 25.3014 30.9053 25.3014 30.885 25.3014H14.3433L13.9155 20.616H18.0713ZM33.2277 29.2535V27.8275H34.3074V34.3056H15.1581L14.7303 29.6202C14.7711 29.6202 14.7915 29.6202 14.8322 29.6202H30.885C30.9053 29.6202 30.9461 29.6202 30.9664 29.6202C30.9868 29.6202 31.0276 29.6202 31.0479 29.6202H32.8814C33.0647 29.5998 33.2277 29.4368 33.2277 29.2535ZM18.8046 28.8868V28.3368C18.8046 28.0312 19.0491 27.8071 19.3547 27.8071C19.6602 27.8071 19.9047 28.0516 19.9047 28.3368V28.8868H18.8046ZM22.4104 28.8868V28.3368C22.4308 28.0312 22.6956 27.8071 22.9808 27.8275C23.2456 27.8479 23.4697 28.072 23.4901 28.3368V28.8868H22.4104ZM26.0162 28.8868V28.3368C26.0365 28.0312 26.3014 27.8071 26.5866 27.8275C26.8514 27.8479 27.0755 28.072 27.0958 28.3368V28.8868H26.0162ZM27.8292 28.9072V28.3775C27.8292 27.6849 27.2588 27.1145 26.5662 27.1145C25.8736 27.1145 25.3032 27.6849 25.3032 28.3775V28.9072H24.2235V28.3775C24.2235 27.6849 23.6531 27.1145 22.9604 27.1145C22.2678 27.1145 21.6974 27.6849 21.6974 28.3775V28.9072H20.6177V28.3775C20.5973 27.6849 20.0066 27.1349 19.2936 27.1552C18.6417 27.1756 18.112 27.7053 18.0713 28.3775V28.9072H14.8118C14.7507 28.9072 14.71 28.9276 14.6489 28.9479L14.384 26.0348H30.5794V28.9072H27.8292ZM2.54817 10.858V7.96526H3.62786V9.41164C3.62786 9.61536 3.79083 9.77833 3.99455 9.77833H5.80761C6.01133 9.77833 6.1743 9.61536 6.1743 9.41164V7.96526H7.25399V9.41164C7.25399 9.61536 7.41696 9.77833 7.62068 9.77833H9.43374C9.63746 9.77833 9.80043 9.61536 9.80043 9.41164V7.96526H10.8801V9.41164C10.8801 9.61536 11.0431 9.77833 11.2264 9.77833H13.0395C13.2432 9.77833 13.4062 9.61536 13.4062 9.41164V7.96526H14.4655V10.858H2.54817ZM12.6524 11.571V14.4638H4.36123V11.571H12.6524ZM4.32049 15.1768H12.6932L13.121 19.8622L13.1821 20.5752L14.4248 34.2853H2.58891L4.32049 15.1768ZM35.0407 34.3056V27.4608C35.0407 27.2571 34.8778 27.1145 34.6741 27.1145H32.861C32.6573 27.1145 32.4943 27.2775 32.4943 27.4812V28.9276H31.2924V26.0552H32.8202C32.9425 26.0552 33.0443 25.9941 33.1258 25.8922C33.1869 25.7903 33.2073 25.6681 33.1666 25.5663L31.3739 20.1474C31.3331 20.0048 31.1905 19.903 31.0276 19.903H29.133L29.5608 15.1972H37.9335L39.6651 34.3056H35.0407Z",
                        fill: "white",
                      },
                    }),
                    _c("path", {
                      attrs: {
                        d: "M6.70395 16.2565C6.01132 16.2565 5.44092 16.8269 5.44092 17.5195V20.2289C5.44092 20.4326 5.60389 20.5956 5.78723 20.5956H7.6003C7.80401 20.5956 7.96699 20.4326 7.96699 20.2289V17.5195C7.96699 16.8269 7.39658 16.2565 6.70395 16.2565ZM7.25398 19.8826H6.17429V17.5195C6.17429 17.2139 6.41875 16.9695 6.72432 16.9695C7.0299 16.9695 7.27435 17.2139 7.27435 17.5195V19.8826H7.25398Z",
                        fill: "white",
                      },
                    }),
                    _c("path", {
                      attrs: {
                        d: "M11.5728 22.9383C11.5728 22.2457 11.0024 21.6753 10.3098 21.6753C9.61715 21.6753 9.04675 22.2457 9.04675 22.9383V25.6478C9.04675 25.8515 9.20972 26.0144 9.41344 26.0144H11.2061C11.4098 26.0144 11.5728 25.8515 11.5728 25.6681V22.9383ZM9.78013 25.2811V22.9383C9.8005 22.6328 10.0653 22.4087 10.3505 22.4291C10.6154 22.4494 10.8394 22.6735 10.8598 22.9383V25.2811H9.78013Z",
                        fill: "white",
                      },
                    }),
                    _c("path", {
                      attrs: {
                        d: "M35.5704 16.2565C34.8778 16.2565 34.3074 16.8269 34.3074 17.5195V20.2289C34.3074 20.4326 34.4703 20.5956 34.6741 20.5956H36.4668C36.6705 20.5956 36.8334 20.4326 36.8334 20.2289V17.5195C36.8334 16.8269 36.2834 16.2565 35.5704 16.2565ZM36.1204 19.8826H35.0407V17.5195C35.0407 17.2139 35.2852 16.9695 35.5908 16.9695C35.8964 16.9695 36.1408 17.2139 36.1408 17.5195V19.8826H36.1204Z",
                        fill: "white",
                      },
                    }),
                  ]
                ),
                _c(
                  "span",
                  { staticClass: "text-uppercase header-title mt-auto ms-1" },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("default.CASTILLOS_Y_PALACIOS.CASTLES")) +
                        " "
                    ),
                  ]
                ),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "d-flex mt-auto",
                class: { "d-none": !_vm.isPalaciosSelected },
              },
              [
                _c(
                  "icon-base",
                  { attrs: { width: 44, height: 35, iconColor: "white" } },
                  [_c("icon-palace")],
                  1
                ),
                _c(
                  "span",
                  { staticClass: "text-uppercase header-title mt-auto ms-1" },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("default.CASTILLOS_Y_PALACIOS.PALACES")) +
                        " "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "text-center my-auto header-text py-2" }, [
            _vm._v(" " + _vm._s(_vm.descripciones) + " "),
          ]),
          _c("div", { staticClass: "d-flex d-lg-none mx-auto my-2" }, [
            _c(
              "button",
              {
                staticClass: "read-more-btn mx-auto mb-1",
                on: { click: () => _vm.toggleFullText() },
              },
              [
                _c("span", { class: { "d-none": _vm.showFullText } }, [
                  _vm._v(_vm._s(_vm.$t("default.BUTTONS.READ_MORE"))),
                ]),
                _c("span", { class: { "d-none": !_vm.showFullText } }, [
                  _vm._v(_vm._s(_vm.$t("default.BUTTONS.READ_LESS"))),
                ]),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "continaer-fluid" },
      [_c("tools-component", { staticStyle: { width: "100%" } })],
      1
    ),
    _c(
      "div",
      { staticClass: "container-fluid px-3 px-md-5" },
      [
        _c("div", { staticClass: "pt-4 mb-3" }, [
          _c("div", { staticClass: "row d-none" }, [
            _c("div", { staticClass: "col-6 my-2" }, [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-column text-center align-items-center",
                  attrs: { role: "button" },
                  on: {
                    click: function ($event) {
                      _vm.selectedType = "Castillos"
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "align-items-center",
                      class: {
                        "spainhn-solid-red-background": _vm.isCastillosSelected,
                        "spainhn-gray-background": !_vm.isCastillosSelected,
                      },
                      staticStyle: {
                        "border-radius": "50%",
                        width: "90px",
                        height: "90px",
                      },
                    },
                    [
                      _c(
                        "icon-base",
                        {
                          staticClass: "p-1",
                          attrs: {
                            width: 70,
                            height: 70,
                            iconColor: _vm.disabledColor,
                          },
                        },
                        [_c("icon-casttle")],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "h-100" }, [
                    _c(
                      "p",
                      {
                        staticClass: "my-auto text-start",
                        class: {
                          "spainhn-subtitle-lg": _vm.isCastillosSelected,
                          "spainhn-subtitle-disabled": !_vm.isCastillosSelected,
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("default.castlesText")))]
                    ),
                  ]),
                ]
              ),
            ]),
            _c("div", { staticClass: "col-6 my-2" }, [
              _c(
                "div",
                {
                  staticClass: "d-flex flex-column align-items-center",
                  attrs: { role: "button" },
                  on: {
                    click: function ($event) {
                      _vm.selectedType = "Palacios"
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      class: {
                        "spainhn-solid-red-background": _vm.isPalaciosSelected,
                        "spainhn-gray-background": !_vm.isPalaciosSelected,
                      },
                      staticStyle: {
                        "border-radius": "50%",
                        width: "90px",
                        height: "90px",
                      },
                    },
                    [
                      _c(
                        "icon-base",
                        {
                          staticClass: "p-1",
                          attrs: {
                            width: 70,
                            height: 70,
                            iconColor: _vm.disabledColor,
                          },
                        },
                        [_c("icon-palace")],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "h-100" }, [
                    _c(
                      "p",
                      {
                        staticClass: "my-auto text-start ms-2",
                        class: {
                          "spainhn-subtitle-lg": _vm.isPalaciosSelected,
                          "spainhn-subtitle-disabled": !_vm.isPalaciosSelected,
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("default.palacesText")))]
                    ),
                  ]),
                ]
              ),
            ]),
          ]),
          _c("div", { staticClass: "row", class: { "d-none": true } }, [
            _c(
              "div",
              {
                staticClass: "d-flex flex-column flex-md-row",
                staticStyle: { width: "33%" },
                attrs: { role: "button" },
                on: {
                  click: function ($event) {
                    _vm.selectedType = "Castillos"
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    class: {
                      "spainhn-solid-red-background": _vm.isCastillosSelected,
                      "spainhn-gray-background": !_vm.isCastillosSelected,
                    },
                    staticStyle: {
                      "border-radius": "50%",
                      width: "80px",
                      height: "80px",
                    },
                  },
                  [
                    _c(
                      "icon-base",
                      {
                        staticClass: "p-1",
                        attrs: {
                          width: 70,
                          height: 70,
                          iconColor: _vm.disabledColor,
                        },
                      },
                      [_c("icon-casttle")],
                      1
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "ms-3 h-100 d-flex" }, [
                  _c(
                    "p",
                    {
                      staticClass: "my-auto",
                      class: {
                        "spainhn-subtitle-lg": _vm.isCastillosSelected,
                        "spainhn-subtitle-disabled": !_vm.isCastillosSelected,
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("default.castlesText")))]
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "d-flex ms-3 flex-column flex-md-row",
                staticStyle: { width: "33%" },
                attrs: { role: "button" },
                on: {
                  click: function ($event) {
                    _vm.selectedType = "Palacios"
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    class: {
                      "spainhn-solid-red-background": _vm.isPalaciosSelected,
                      "spainhn-gray-background": !_vm.isPalaciosSelected,
                    },
                    staticStyle: {
                      "border-radius": "50%",
                      width: "80px",
                      height: "80px",
                    },
                  },
                  [
                    _c(
                      "icon-base",
                      {
                        staticClass: "p-1",
                        attrs: {
                          width: 70,
                          height: 70,
                          iconColor: _vm.disabledColor,
                        },
                      },
                      [_c("icon-palace")],
                      1
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "ms-2 h-100 d-flex" }, [
                  _c(
                    "p",
                    {
                      staticClass: "my-auto",
                      class: {
                        "spainhn-subtitle-lg": _vm.isPalaciosSelected,
                        "spainhn-subtitle-disabled": !_vm.isPalaciosSelected,
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("default.palacesText")))]
                  ),
                ]),
              ]
            ),
          ]),
        ]),
        _c("div", {
          staticClass: "w-100 border-bottom my-auto d-none",
          staticStyle: {
            height: "2vh",
            "border-color": "rgb(242,90,85) !important",
          },
        }),
        _c("div", { staticClass: "d-flex justify-content-around pt-1 mb-1" }),
        _c(
          "div",
          { staticClass: "d-none mb-5 d-md-flex" },
          [
            _c("b-select", {
              staticClass: "mt-2 spainhn-custom-input me-3 w-100",
              attrs: { options: _vm.comunidadesAutonomas },
              on: { change: _vm.filterByComunidad },
              model: {
                value: _vm.localizacionFilter,
                callback: function ($$v) {
                  _vm.localizacionFilter = $$v
                },
                expression: "localizacionFilter",
              },
            }),
            _c("b-select", {
              staticClass:
                "mt-2 spainhn-custom-input mx-1 w-100 overflow-hidden",
              attrs: { options: _vm.rutasOptionsFiltered },
              on: { change: _vm.filterByRutas },
              model: {
                value: _vm.rutaFilter,
                callback: function ($$v) {
                  _vm.rutaFilter = $$v
                },
                expression: "rutaFilter",
              },
            }),
            _c("b-select", {
              staticClass: "mt-2 spainhn-custom-input ms-3 w-100",
              attrs: { options: _vm.monumentosFiltered },
              on: { change: _vm.filterByMonument },
              model: {
                value: _vm.castilloFilter,
                callback: function ($$v) {
                  _vm.castilloFilter = $$v
                },
                expression: "castilloFilter",
              },
            }),
          ],
          1
        ),
        _c("b-spinner", {
          staticClass: "d-flex mx-auto",
          class: { "d-none": !_vm.loading },
          attrs: { variant: "danger" },
        }),
        _c(
          "div",
          { staticClass: "row d-md-none" },
          _vm._l(_vm.edificiosFiltered, function (edificio, index) {
            return _c(
              "div",
              { key: index, staticClass: "col px-0" },
              [
                _c("cards-general", {
                  attrs: {
                    subtitle: `${edificio?.provincia}, ${edificio?.municipio}`,
                    title: edificio.webName,
                    "image-url": `${_vm.imagenUrl}/monumentos/${edificio?.oldId}/${edificio?.imagen}`,
                    type: "monumento",
                  },
                  on: {
                    goToUrl: () => _vm.goToUrl(edificio.nombreNormalizado),
                  },
                }),
              ],
              1
            )
          }),
          0
        ),
        _c("div", { staticClass: "d-none d-md-flex mb-5" }, [
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-around px-0 mx-auto w-100 flex-wrap",
            },
            _vm._l(_vm.edificiosFiltered, function (edificio, index) {
              return _c("cards-2", {
                key: index,
                attrs: {
                  monument: edificio.webName,
                  provincia: edificio.provincia,
                  municipio: edificio.municipio,
                  imageUrl: `${_vm.imagenUrl}/monumentos/${edificio.oldId}/${edificio.imagen}`,
                  text: edificio.webDescription,
                  id: edificio.id,
                  nombreUrl: edificio.nombreNormalizado,
                  role: "button",
                },
              })
            }),
            1
          ),
        ]),
        _c("div", { staticClass: "d-flex mb-5" }, [
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-around px-0 mx-auto w-100 flex-wrap",
            },
            _vm._l(_vm.edificiosFilteredWithFilter, function (edificio, index) {
              return _c("cards-2", {
                key: index,
                attrs: {
                  monument: edificio.webName,
                  provincia: edificio.provincia,
                  municipio: edificio.municipio,
                  imageUrl: `${_vm.imagenUrl}/monumentos/${edificio.oldId}/${edificio.imagen}`,
                  text: edificio.webDescription,
                  id: edificio.id,
                  nombreUrl: edificio.nombreNormalizado,
                  role: "button",
                },
              })
            }),
            1
          ),
        ]),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "mt-3" },
      [
        _c("div", { staticClass: "spainhn-header-info mb-2" }, [
          _vm._v(" " + _vm._s(_vm.$t("default.HOME_RESULTS_MAP_LABEL")) + " "),
        ]),
        _c("MiniMap", { staticClass: "d-md-none mx-auto" }),
      ],
      1
    ),
    _c("div", { staticClass: "mt-3" }, [_c("ComponentsCloud")], 1),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }